






























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {WardParams} from "../../params";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {debounce} from "lodash";
import {WardStore} from "@/modules/regionsv2/ward/store";
import WardForm from "@/modules/regionsv2/ward/Form/index.vue";
import DistrictSelectorV2 from "@/modules/regionsv2/DistrictSelectorV2/index.vue";
import ProvinceSelectorV2 from "@/modules/regionsv2/ProvinceSelectorV2/index.vue";
import DistrictSearchSelectorV2 from "@/modules/regionsv2/DistrictSearchSelectorV2/index.vue";
import ProvinceSearchSelectorV2 from "@/modules/regionsv2/ProvinceSearchSelectorV2/index.vue";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: 'WardSearch',
    components: {
        ProvinceSearchSelectorV2,
        DistrictSearchSelectorV2, ProvinceSelectorV2, DistrictSelectorV2, WardForm, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params = new WardParams();
    paramPlus = { provinceId: undefined };
    provinceId = null;
    CommonStatus = CommonStatus;
    visibleForm = false;

    @Watch("params", { immediate: true, deep: true })
    onChangeParams(val) {
        this.handleChangeParams(val);
    }

    handleChangeParams = debounce((val) => {
        WardStore.paramsChangeWardV21({ ...val, page: 1 });
    }, 300)

    create() {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_CREATE_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        this.visibleForm = true;
    }
}
